import { useTranslation, Trans } from 'react-i18next'
import safariHero from '../../assets/assets-safari/safari-hero.webp'
import safariHeroMobile from '../../assets/assets-safari/safari-hero-mobile.jpg'
import WhereYoullGoSlider from './SafariComponents/WhereYoullGoSlider'
import WhyChoosingSafariGrid from './SafariComponents/WhyChoosingSafariGrid'

import '../../assets/assets-homepage/css/reset.scss'
import '../../assets/assets-homepage/css/page.scss'
import '../../assets/assets-homepage/fonts/Inter/stylesheet.css'

import SafariEditSlider from './SafariComponents/SafariEditSlider'
import FounderSafari from './SafariComponents/FounderSafari'
import WhyWorkWithXploriusSafari from './SafariComponents/WhyWorkWithXploriusSafari'
import HowItWorks from './MaldivesComponents/HowItWorks'
import SafariLodgesSlider from './SafariComponents/SafariLodgesSlider'
import { PublicHeader, PublicFooter } from '../../components/common'
import TrustedSection from './HomeComponents/TrustedSection'
import SpeakToExpertButton from 'src/components/home/SpeakToExpertButton'
import Whatsapp from './HomePageComponents/Whatsapp'

export const Safari = () => {
    const { t, i18n } = useTranslation('safari')
    const { t: tCommon } = useTranslation('common')
    const isRu = i18n.language === 'ru'
    const safariNavLinks = [
        { label: tCommon('nav.safari.home'), href: '/' },
        { label: tCommon('nav.safari.privateJets'), href: '#' },
        { label: tCommon('nav.safari.maldives'), href: '/maldives' },
    ]
    return <>
        <PublicHeader
            variant="dark"
            navLinks={safariNavLinks}
            showLanguageSwitcher={true}
            position="absolute"
            borderBottom
        />

        <main>
            <section className='relative h-[100dvh] flex items-center sm:justify-center flex-col pt-[120px]'>
                <picture>
                    <source media='(min-width: 640px)' srcSet={safariHero} />
                    <img src={safariHeroMobile} alt={t('hero.alt')} className='w-full h-full object-cover absolute inset-0' />
                </picture>

                <div className='absolute inset-0 pointer-events-none safari-hero-shadow' />

                <div className='flex items-center justify-center flex-col relative text-center px-5'>
                    <h1 className={`relative text-[min(6.25vw,24px)] sm:text-2xl lg:text-[44px] text-white uppercase font-semibold mb-3 sm:mb-6 lg:mb-8 leading-none ${isRu && 'tracking-wider sm:tracking-normal !leading-snug'}`}>
                        {t('hero.title')}
                    </h1>

                    <p className={`relative text-white text-[min(4.375vw,16px)] sm:text-base ${isRu ? 'lg:text-[28px] sm:uppercase !leading-normal lg:!leading-tight max-w-[426px] lg:max-w-[1018px]' : 'lg:text-xl max-w-[452px] lg:max-w-[797px]'} mb-3 sm:mb-[26px] lg:mb-11`}>
                        {t('hero.subtitle')}
                    </p>

                    <SpeakToExpertButton text={tCommon('cta.planSafariAdventure')} />
                </div>

                <div className='absolute bottom-[15px] sm:bottom-[34px] left-0 right-0 py-5'>
                    <div className='max-w-[1600px] px-10 mx-auto grid sm:grid-cols-3'>
                        <div className='flex items-center'>
                            <p className='italic text-white font-light lg:text-base text-xs uppercase'>
                                <Trans
                                    i18nKey="hero.featured"
                                    ns="safari"
                                    components={{
                                        strong1: <span className='font-semibold' />,
                                        strong2: <span className='font-semibold' />,
                                        br1: <br className='sm:hidden' />,
                                    }}
                                />
                            </p>
                        </div>

                        <div className='flex justify-center'>
                            <button onClick={() => document.getElementById('safari-content')?.scrollIntoView({ behavior: 'smooth' })}>
                                <svg className='lg:w-[50px] lg:h-[50px] sm:w-10 sm:h-10 w-6 h-6' viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M33.703 36.4076L35.4056 38.0771L26.1262 47.1703C25.9775 47.3169 25.8007 47.4332 25.6059 47.5126C25.4112 47.5919 25.2023 47.6328 24.9913 47.6328C24.7804 47.6328 24.5715 47.5919 24.3768 47.5126C24.182 47.4332 24.0052 47.3169 23.8565 47.1703L14.5723 38.0771L16.2749 36.4092L24.9889 44.9438L33.703 36.4076Z" fill="#EFE8DF" />
                                    <path opacity="0.7" d="M33.703 24.4076L35.4056 26.0771L26.1262 35.1703C25.9775 35.3169 25.8007 35.4332 25.6059 35.5126C25.4112 35.5919 25.2023 35.6328 24.9913 35.6328C24.7804 35.6328 24.5715 35.5919 24.3768 35.5126C24.182 35.4332 24.0052 35.3169 23.8565 35.1703L14.5723 26.0771L16.2749 24.4092L24.9889 32.9438L33.703 24.4076Z" fill="#EFE8DF" />
                                    <path opacity="0.2" d="M33.703 12.4076L35.4056 14.0771L26.1262 23.1703C25.9775 23.3169 25.8007 23.4332 25.6059 23.5126C25.4112 23.5919 25.2023 23.6328 24.9913 23.6328C24.7804 23.6328 24.5715 23.5919 24.3768 23.5126C24.182 23.4332 24.0052 23.3169 23.8565 23.1703L14.5723 14.0771L16.2749 12.4092L24.9889 20.9438L33.703 12.4076Z" fill="#EFE8DF" />
                                </svg>
                            </button>
                        </div>

                        <div></div>
                    </div>
                </div>
            </section>

            <div id="safari-content" className="homePage wrapper">
                <Whatsapp />
                <WhereYoullGoSlider />
                <TrustedSection />
                <WhyChoosingSafariGrid />
                <SafariEditSlider />
                <FounderSafari />
                <WhyWorkWithXploriusSafari />
                <HowItWorks safari={true} />
                <SafariLodgesSlider />
            </div>
        </main>

        <PublicFooter />
    </>
}
